import * as uri from 'urijs';

export interface CallApiOptions {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  endpoint: string;
  params?: {
    [key: string]: any;
  };
  data?: any;
  token?: string;
  withAuth?: boolean;
  body?: any;
  apiUrl?: string;
  noContentType?: boolean;
}

export async function callService<DataType>(
  options: CallApiOptions,
  headers: Headers
) {
  const url = uri(options.endpoint)
    .setQuery(options.params as any)
    .normalize();

  const fetchOptions = {
    headers: headers,
    method: options.method,
    body: options.body,
  };

  const response = await fetch(url.href(), fetchOptions);

  const contentType = response.headers.get('content-type');
  const isJson = contentType && contentType.indexOf('application/json') !== -1;
  const data = isJson ? await response.json() : await response.text();

  return {
    ok: response.ok,
    data: data as DataType,
    statusCode: response.status,
  };
}



// WEBPACK FOOTER //
// ./src/services/api.ts